// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2mATg","infoBtn":"quickbooks_infoBtn__2eIJO","formBox":"quickbooks_formBox__2xAoy","formFooter":"quickbooks_formFooter__XfbTE"};